import { Title } from "@mantine/core";

export function HeaderLeft() {
  return <Title>Product Serial Number</Title>;
}
